import { useRef, useState } from "react";
import { Button, Checkbox, Form, Modal } from "react-bootstrap";
import { useBudgets, UNCATEGORIZED_BUDGET_ID } from "../contexts/BudgetContext";

export default function AddExpenseModal({
  show,
  handleClose,
  defaultBudgetId,
}) {
  const descriptionRef = useRef();
  const amountRef = useRef();
  const dateRef = useRef();
  const alignedRef = useRef();
  const budgetIdRef = useRef();
  const { addExpense, budgets } = useBudgets();
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().slice(0, 10)
  );
  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
    // You don't need to manually update the ref - React handles this with value/onChange
  };

  function handleSubmit(e) {
    e.preventDefault();
    var alignedVal = 0;
    if (alignedRef.current.checked == true) alignedVal = 1;

    addExpense({
      description: descriptionRef.current.value,
      amount: parseFloat(amountRef.current.value),
      date: new Date(selectedDate + "T00:00:00").getTime(),
      aligned: alignedVal,
      budgetId: budgetIdRef.current.value,
    });
    handleClose();
  }

  return (
    <Modal show={show} onHide={handleClose}>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>New Expense</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3" controlId="description">
            <Form.Label>Description</Form.Label>
            <Form.Control
              ref={descriptionRef}
              type="text"
              required
            ></Form.Control>
          </Form.Group>
          <Form.Group className="mb-3" controlId="amount">
            <Form.Label>Amount</Form.Label>
            <Form.Control
              ref={amountRef}
              type="number"
              required
              min={0}
              step={0.01}
            ></Form.Control>
          </Form.Group>
          <Form.Group className="mb-3" controlId="budgetId">
            <Form.Label>Budget</Form.Label>
            <Form.Select defaultValue={defaultBudgetId} ref={budgetIdRef}>
              <option id={UNCATEGORIZED_BUDGET_ID}>
                {UNCATEGORIZED_BUDGET_ID}
              </option>
              {budgets.map((budget) => (
                <option key={budget.id} value={budget.id}>
                  {budget.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3" controlId="date">
            <Form.Label>Date</Form.Label>
            <Form.Control
              ref={dateRef}
              type="date"
              required
              value={selectedDate}
              onChange={handleDateChange}
            ></Form.Control>
          </Form.Group>
          <Form.Group className="mb-3" controlId="aligned">
            <Form.Check
              type={`Checkbox`}
              ref={alignedRef}
              id={`aligned`}
              value={`1`}
              defaultChecked={false}
              label={`\u{1F600} Aligned with values?`}
            />
          </Form.Group>
          <div className="d-flex justify-content-end">
            <Button variant="primary" type="submit">
              Add
            </Button>
          </div>
        </Modal.Body>
      </Form>
    </Modal>
  );
}
